exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".autoWidth[data-v-0ea3f715]{width:100% !important;max-width:none !important}\n", ""]);

